// import effectManager from '../effect';
// import pararax3d from '../mouse/3dPararax';
//
// const effect = new effectManager();
// const para3d = new pararax3d();

/* ---------------------------------------

    -- ループで動作するようなアニメーション

--------------------------------------- */
export default class AnimationMnager{
    constructor(){
    }
    illustLoop($target,type){

        let _tl = new TimelineMax({repeat:-1});

        if(type==="start") {

            _tl.to($target,0.1,{
                rotation : 20,
            });
            _tl.to($target,0.1,{
                rotation : -20,
            });

        }else{

        }
    }
    svgPathMorph($target,morphPath,type,speed){

        let _tl = (type==="loop")?new TimelineMax({repeat:-1}):new TimelineMax();


        for(let i=0; morphPath.length>i; i++){

            _tl.to($target,speed,{
                morphSVG : morphPath[i],
                // ease : (i%2===0)?Back.easeOut.config(2):Back.easeIn.config(2)
                ease : Sine.easeInOut
                // ease: Elastic.easeInOut.config(1, 0.75),
            }, "+=0.001");

        }

        if(type==="loop"){
            _tl.to($target,1.38,{
                morphSVG : $target,
                // ease : Sine.easeOut
                ease : Sine.easeInOut
            }, "+=0.001");
        }


        // TweenMax.set($target,{"transform-origin": "27% 27%"})
        //
        // TweenMax.to($target,1.38,{
        //     rotation : 360,
        //     repeat:-1
        //     // ease : Back.easeOut.config(2)
        // });



    }
}